import apiClient from '../lib/apiClient';

const hrManagementService = {
  // Get all HR users
  getHRUsers: async (filters = {}) => {
    try {
      const result = await apiClient.get('/hr-management', filters);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch HR users' };
    }
  },

  // Get single HR user by ID
  getHRUser: async (id) => {
    try {
      const result = await apiClient.get(`/hr-management/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch HR user' };
    }
  },

  // Create new HR user
  createHRUser: async (userData) => {
    try {
      const result = await apiClient.post('/hr-management', userData);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to create HR user' };
    }
  },

  // Update HR user
  updateHRUser: async (id, userData) => {
    try {
      const result = await apiClient.put(`/hr-management/${id}`, userData);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update HR user' };
    }
  },

  // Delete HR user
  deleteHRUser: async (id) => {
    try {
      const result = await apiClient.delete(`/hr-management/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to delete HR user' };
    }
  }
};

export default hrManagementService;

